import { useMemo } from 'react';

import {
  ItemSetQuestionLOSSelector,
  type ItemSetQuestionLOSSelectorProps,
} from '../item-set-question-los-selector';
import {
  SingleQuestionLOSSelector,
  type SingleQuestionLOSSelectorProps,
} from '../single-question-los-selector';
import { TopicSelector, type TopicSelectorProps } from '../topic-selector';

type QuestionLOSSelectorPropsByContentType =
  | (SingleQuestionLOSSelectorProps & { questionType: 'single' })
  | (ItemSetQuestionLOSSelectorProps & { questionType: 'item-set' });

export type ContentSelectorByContentTypeProps = Omit<TopicSelectorProps, 'isSomeTopicSelected'> &
  QuestionLOSSelectorPropsByContentType & {
    contentType: 'LOS' | 'TOPIC';
  };

export default function ContentSelectorByContentType(
  props: Readonly<ContentSelectorByContentTypeProps>,
) {
  const { group, onEdit, location, levelItemsWithLevel, contentType, questionType } = props;
  const isSelectLOS = contentType === 'LOS' && group;
  const isSelectTopic = contentType === 'TOPIC';
  const isSomeTopicSelected = useMemo(() => {
    if (location?.topics != undefined) {
      return (
        Object.entries(location.topics)
          .filter(([, value]) => value)
          .map(([key]) => key).length > 0
      );
    } else {
      return false;
    }
  }, [location]);

  if (isSelectLOS) {
    if (questionType === 'single') {
      return <SingleQuestionLOSSelector group={group} />;
    }

    if (questionType === 'item-set') {
      return <ItemSetQuestionLOSSelector group={group} questionSize={props.questionSize} />;
    }
  }

  if (isSelectTopic) {
    return (
      <TopicSelector
        onEdit={onEdit}
        isSomeTopicSelected={isSomeTopicSelected}
        location={location}
        levelItemsWithLevel={levelItemsWithLevel}
      />
    );
  }
}
